import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table as AddonsTable } from '@jarvis/react-portal-addons';

export const Table = ({
  columns, data, preferences, source, pagination = true,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = page => setCurrentPage(page);
  const handlePageSizeChange = (event, option) => setPageSize(option.value);

  const pagedData = pagination
    ? data.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize,
    )
    : data;

  // Reset to first page when data source changes
  useEffect(() => {
    setCurrentPage(1);
  }, [source]);

  // Reset to first page when pagination is disabled
  useEffect(() => {
    if (!pagination) {
      setCurrentPage(1);
    }
  }, [pagination]);

  const paginationProps = pagination
    ? {
      currentPage,
      onPageChange: handlePageChange,
      onPageSizeChange: handlePageSizeChange,
      pageSize,
      totalItems: data.length,
    }
    : undefined;

  return (
    <AddonsTable
      tableData={{
        columnResize: true,
        columns,
        data: pagedData,
        preferences,
        pagination: paginationProps,
      }}
    />
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  preferences: PropTypes.shape({
    width: PropTypes.arrayOf(PropTypes.number),
  }),
  source: PropTypes.string,
  pagination: PropTypes.bool,
};

Table.defaultProps = {
  data: [],
  preferences: {},
  source: '',
  pagination: true,
};

export default Table;
